import React from 'react'
import * as appAction from "../actions/appactions";
import { useDispatch, useSelector } from "react-redux";

export default function PreLoadingIndicator() {
    const state = useSelector((state) => state.appReducer);
    if (state.preLoadingIndicatorCounter > 0) {
        return (
            <>
                <p className="placeholder-glow">
                    <span class="placeholder col-12"></span>
                </p>
                <p className="placeholder-glow">
                    <span class="placeholder col-12"></span>
                </p>
            </>
        );
    }
}
